import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './/app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';
import { MODULES } from './global-modules';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ClickableClickModule } from 'angular-clickable-click';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChangePasswordChallengeComponent } from './auth/change-password-challenge/change-password-challenge.component';
import { FooterModule } from './pages/footer/footer.module';
import { ConfirmComponent } from './utils/confirm/confirm.component';
import { EmailInputComponent } from './utils/email-input/email-input.component';
import { ImageDialogComponent } from './services/dialog/image-dialog/image-dialog.component';
import { AlertDialogComponent } from './services/dialog/alert-dialog/alert-dialog.component';
import { DirectivesModule } from './directives/directives.module';
import { LoadingComponent } from './services/dialog/loading/loading.component';
import { PrivacyPolicyComponent } from './auth/privacy-policy/privacy-policy.component';
import { SharedComponentsModule } from './_shared-components/shared-components.module';
import { PrivacyNoticeDialogComponent } from './services/dialog/privacy-notice-dialog/privacy-notice-dialog.component';
import { UnsavedChangesGuard } from './guards/UnsavedChangesGuard';
import { OtpVerificationComponent } from './services/dialog/otp-verification/otp-verification.component';
import Amplify from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { BookingSummaryDialogComponent } from './services/dialog/booking-summary-dialog/booking-summary-dialog.component';

Amplify.configure({
  Auth: environment.auth,
  API: environment.api
})

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        PageNotFoundComponent,
        ChangePasswordChallengeComponent,
        ConfirmComponent,
        EmailInputComponent,
        ImageDialogComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        AlertDialogComponent,
        LoadingComponent,
        PrivacyPolicyComponent,
        PrivacyNoticeDialogComponent,
        OtpVerificationComponent,
        BookingSummaryDialogComponent,
    ],
    imports: [
        BrowserModule,
        FooterModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ClickableClickModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            useDefaultLang: true,
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        DirectivesModule,
      ...MODULES,
      SharedComponentsModule
    ],
    providers:[UnsavedChangesGuard],
    bootstrap: [AppComponent]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer){
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));
  }
}
